import DOMPurify from "isomorphic-dompurify"

/**
 * sanitizeHtml
 * Removes executable markup from HTML before React dangerouslySetInnerHTML.
 *
 * @param {string} dirtyHtml
 * @return {string}
 */
export const sanitizeHtml = (dirtyHtml) => {
  if (dirtyHtml == null || dirtyHtml === "") return ""

  return DOMPurify.sanitize(String(dirtyHtml), {
    USE_PROFILES: { html: true },
  })
}
